import React from 'react'
import { range } from 'libraries/lodash'
import PaginationItem from 'components/search/PaginationItem'
import { touchLink } from 'helpers/TouchClick'

const PaginationList = ({ pageNumber, pageCount, getLink }) => {
  const lowerPageLimit = Math.max(1, pageNumber - 5)
  const upperPageLimit = Math.min(lowerPageLimit + 10, pageCount + 1)

  return (
    <ul className='flex bt bl bb b--phantom-grey bg-white br1 list-reset pa0'>
      {range(lowerPageLimit, upperPageLimit, 1).map(page => (
        <PaginationItem
          key={page}
          link={getLink(page)}
          {...{ page, pageNumber, ...touchLink }}
        />
      ))}
    </ul>
  )
}

export default PaginationList
